import { render, staticRenderFns } from "./DashboardWelcome.vue?vue&type=template&id=6eda0ba1&scoped=true"
import script from "./DashboardWelcome.vue?vue&type=script&lang=js"
export * from "./DashboardWelcome.vue?vue&type=script&lang=js"
import style0 from "./DashboardWelcome.vue?vue&type=style&index=0&id=6eda0ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eda0ba1",
  null
  
)

export default component.exports